import React from "react";

const RemoveTenantModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-extrabold mb-4 text-center text-[#4F4F4F]">
          Remove User
        </h2>
        <p className="mb-6 font-semibold text-center text-[#828282]">
          Are you sure you want to Remove this user?
        </p>
        <div className="flex justify-center space-x-4">
          <button
            className="px-4 py-2 bg-[#fff] border border-[#0074bb] text-[#0074bb] rounded hover:bg-[#dad5d54e]"
            onClick={onClose}
          >
            No
          </button>

          <button
            className="px-4 py-2 bg-[#0074bb] text-[#fff] rounded hover:bg-[#0054bb]"
            // onClick={onConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveTenantModal;
